export const EXCLUDED_COMMENT_SUGGESTION_LIMIT = 50;
